import cx from 'classnames'
import type React from 'react'

import { Block } from '../Block'
import { getDragAndDropAttributes } from '../DragAndDrop/getDragAndDropAttributes'
import { DROPZONE_TYPE } from '../DragAndDrop/types'
import BlockDropzone from './BlockDropzone'
import css from './Blocks.module.scss'

import './Blocks.scss'

type BlocksListType = {
  nodeId: string
  ids: string[]
}

const BlocksList: React.FC<BlocksListType> = ({ nodeId, ids }) => {
  if (!ids) {
    return null
  }

  return (
    <div className={css.container}>
      {ids.map((id, index) => {
        const pseudoIdUp = `${nodeId}_${id}_${index}_0`
        const pseudoIdDown = `${nodeId}_${id}_${index}_1`
        const blockData = {
          blockId: id,
          nodeId,
          index: index - 0.5,
        }

        const isFirst = index === 0
        const isLast = index === ids.length - 1

        return (
          <div className={cx(css.dropzoneWrapper, 'block')} id={id} key={index}>
            <BlockDropzone blockId={id} id={pseudoIdUp} data={blockData} />

            <div className={css.pseudoDropzoneWrapper}>
              <Block
                index={index}
                id={id}
                nodeId={nodeId}
                isFirst={isFirst}
                isLast={isLast}
              />

              {isFirst && (
                <div
                  className={cx(css.pseudoDropzoneUp, 'block-dropzone')}
                  {...getDragAndDropAttributes(
                    pseudoIdUp,
                    DROPZONE_TYPE.BLOCK,
                    {
                      ...blockData,
                      index: -1,
                    }
                  )}
                />
              )}

              <div
                className={cx(css.pseudoDropzoneDown, 'block-dropzone')}
                {...getDragAndDropAttributes(
                  pseudoIdDown,
                  DROPZONE_TYPE.BLOCK,
                  { ...blockData, index }
                )}
              />
            </div>

            <BlockDropzone
              blockId={id}
              id={pseudoIdDown}
              data={{
                ...blockData,
                index: index + 0.5,
              }}
            />
          </div>
        )
      })}
    </div>
  )
}

export default BlocksList
